import { Text } from '@doist/marketist'

import cn from 'classnames'

import css from './Paragraph.module.css'

export type ParagraphProps = {
    className?: string
    children?: React.ReactNode
}

export function Paragraph({ className, children, ...rest }: ParagraphProps) {
    return (
        <Text className={cn(css.paragraph, className)} size="body-base" {...rest}>
            {children}
        </Text>
    )
}
